import { mParticleListingFields } from '../../schemas/rql';
import Listing from '../../components/discovery/listing';

export function apiListingToMparticleListing(listing: Listing): mParticleListingFields.Fragment {
  return {
    id: listing.id,
    title: listing.title,
    bumpEligible: listing.bumped,
    pricing: {
      buyerPrice: listing.buyer_price,
    },
    condition: {
      conditionUuid: listing.condition.uuid,
      conditionSlug: listing.condition.slug,
    },
    categoryUuids: listing.category_uuids,
  };
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/lib/adapters/api_listing_to_mparticle_fragment.ts